import {
  EducationIcon_default
} from "./chunk-OLO73BG6.mjs";
export {
  EducationIcon_default as default
};
